/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class FormatterAPI
 * @hideconstructor
 *
 * @classdesc implementation of the FormatterAPI interface.
 */
define([], () => {

	class FormatterAPI {

		/**
		 * @function FormatterAPI#destroy
		 * @description Used to destroy the FormatterAPI object
		 */
		destroy() {}

		/**
		 * @function FormatterAPI#registerProvider
		 * @description Register a provider as a formatter for specific types of values.
		 * @param {String} type of values that should use the format provider.
		 * 		When passing undefined, it will replace the default formatter, becoming the new default
		 * @param {FormatterProviderAPI} provider the format provider to be used
		 */
		registerProvider(/* type, provider */) {}

		/**
		 * @function FormatterAPI#format
		 * @description Formats a value using a specification
		 * @param {String || Number} value the value to format
		 * @param {Object} spec that specifies how the value is to be formatted
		 * @return {String} value formatted as specified in spec
		 * 
		 * When this function is called, it will use the "best" formatter provider that's available.
		 * 	If using a registerd provider, call FormatterProviderAPI.format(value, spec)
		 * 	Otherwise, use the default formatter (dashboard-common's Formatter)
		 * 
		 * NOTE: since the dashboard-common Formatter is currently located in dashboard-livewidget,
		 * we had to keep this feature in the LW repo as well. This function seems more like a
		 * dashboard-core feature though. TODO: move this feature (and FormaterProviderAPI) to dashboard-core
		 */
		format(/* value, spec */) {}
	}

	return FormatterAPI;
});